// Core imports
import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import PropTypes from 'prop-types';

// Component imports
import { Tabs } from 'antd';
import AutomatedAgentTestsForm from '../Forms/AutomatedAgentTestsForm';
import AutomatedAgentTestsResultsView from './AutomatedAgentTestsResultsView';

// Misc imports

// Constants
export const AUTOMATED_TEST_TABS = {
  DETAILS: 'details',
  RESULTS: 'results'
};

const TABS_CONFIG = [
  {
    key: AUTOMATED_TEST_TABS.DETAILS,
    label: t('Details'),
    children: (props) => <AutomatedAgentTestsForm {...props} />
  },
  {
    key: AUTOMATED_TEST_TABS.RESULTS,
    label: t('Results'),
    children: (props) => <AutomatedAgentTestsResultsView {...props} />,
    hideOnCreate: true
  }
];

const AutomatedAgentTestsSideModalTabs = (props) => {
  const { activeAutomatedTest, onFormChange, formRef, handleShowConfirm } = props;

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const activeTab = searchParams.get('tab') || AUTOMATED_TEST_TABS.DETAILS;

  const onTabChange = (newTabKey) => {
    const navigateToNewTab = () => {
      const urlSearchParams = new URLSearchParams(searchParams);
      urlSearchParams.set('tab', newTabKey);
      setTimeout(() => {
        navigate({ search: urlSearchParams.toString() }, { replace: true });
      }, 100);
    };
    handleShowConfirm(navigateToNewTab);
  };

  const items = TABS_CONFIG
    .filter(tab => (activeAutomatedTest?.isCreateMode ? !tab.hideOnCreate : true))
    .map(tab => ({
      ...tab,
      children: tab.key === activeTab ? tab.children({ activeAutomatedTest, ref: formRef, onFormChange }) : null
    }));

  return <Tabs activeKey={activeTab} onChange={onTabChange} items={items} />;
};

AutomatedAgentTestsSideModalTabs.propTypes = {
  activeAutomatedTest: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.oneOf([null])
  ]),
  onFormChange: PropTypes.func.isRequired,
  formRef: PropTypes.object.isRequired,
  handleShowConfirm: PropTypes.func.isRequired
};

export default AutomatedAgentTestsSideModalTabs;
